__turbopack_context__.v({
  "background": "KRailsView-module__YftrPG__background",
  "container": "KRailsView-module__YftrPG__container",
  "dashboardWrapper": "KRailsView-module__YftrPG__dashboardWrapper",
  "lastSection": "KRailsView-module__YftrPG__lastSection",
  "videoSection": "KRailsView-module__YftrPG__videoSection",
  "whoWeServe": "KRailsView-module__YftrPG__whoWeServe",
});
